import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const DnrFlagBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-border bg-transparent text-foreground">
      {t('component:badge.dnrFlag')}
    </Badge>
  );
};
